/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Sync run summary for one integration type
 * @export
 * @interface WebApiAdminDtoIntegrationSyncSummaryDto
 */
export interface WebApiAdminDtoIntegrationSyncSummaryDto {
    /**
     * "Fortnox" or "Spiris"
     * @type {string}
     * @memberof WebApiAdminDtoIntegrationSyncSummaryDto
     */
    integrationName?: string | null;
    /**
     * Number of companies with an Integration row of this type, in any state
     * @type {number}
     * @memberof WebApiAdminDtoIntegrationSyncSummaryDto
     */
    configuredCompanies?: number;
    /**
     * Number of companies whose integration of this type is currently Active
     * @type {number}
     * @memberof WebApiAdminDtoIntegrationSyncSummaryDto
     */
    activeCompanies?: number;
    /**
     * When the most recent sync run of this type happened, across all companies
     * @type {Date}
     * @memberof WebApiAdminDtoIntegrationSyncSummaryDto
     */
    lastSyncAt?: Date | null;
    /**
     * Sync runs (successful + failed) logged today
     * @type {number}
     * @memberof WebApiAdminDtoIntegrationSyncSummaryDto
     */
    runsToday?: number;
    /**
     * Successful sync runs logged today
     * @type {number}
     * @memberof WebApiAdminDtoIntegrationSyncSummaryDto
     */
    successfulRunsToday?: number;
    /**
     * Failed sync runs logged today
     * @type {number}
     * @memberof WebApiAdminDtoIntegrationSyncSummaryDto
     */
    failedRunsToday?: number;
    /**
     * Sync runs logged in the last 7 days
     * @type {number}
     * @memberof WebApiAdminDtoIntegrationSyncSummaryDto
     */
    runsThisWeek?: number;
    /**
     * Failed sync runs logged in the last 7 days
     * @type {number}
     * @memberof WebApiAdminDtoIntegrationSyncSummaryDto
     */
    failedRunsThisWeek?: number;
    /**
     * Sum of items synced (History.Count) across successful runs today
     * @type {number}
     * @memberof WebApiAdminDtoIntegrationSyncSummaryDto
     */
    itemsSyncedToday?: number;
    /**
     * Sum of items updated (parsed out of the sync summary text) across successful runs today
     * @type {number}
     * @memberof WebApiAdminDtoIntegrationSyncSummaryDto
     */
    itemsUpdatedToday?: number;
    /**
     * Number of distinct companies that had a sync run today
     * @type {number}
     * @memberof WebApiAdminDtoIntegrationSyncSummaryDto
     */
    companiesSyncedToday?: number;
}

/**
 * Check if a given object implements the WebApiAdminDtoIntegrationSyncSummaryDto interface.
 */
export function instanceOfWebApiAdminDtoIntegrationSyncSummaryDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoIntegrationSyncSummaryDtoFromJSON(json: any): WebApiAdminDtoIntegrationSyncSummaryDto {
    return WebApiAdminDtoIntegrationSyncSummaryDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoIntegrationSyncSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoIntegrationSyncSummaryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'integrationName': !exists(json, 'integrationName') ? undefined : json['integrationName'],
        'configuredCompanies': !exists(json, 'configuredCompanies') ? undefined : json['configuredCompanies'],
        'activeCompanies': !exists(json, 'activeCompanies') ? undefined : json['activeCompanies'],
        'lastSyncAt': !exists(json, 'lastSyncAt') ? undefined : (json['lastSyncAt'] === null ? null : new Date(json['lastSyncAt'])),
        'runsToday': !exists(json, 'runsToday') ? undefined : json['runsToday'],
        'successfulRunsToday': !exists(json, 'successfulRunsToday') ? undefined : json['successfulRunsToday'],
        'failedRunsToday': !exists(json, 'failedRunsToday') ? undefined : json['failedRunsToday'],
        'runsThisWeek': !exists(json, 'runsThisWeek') ? undefined : json['runsThisWeek'],
        'failedRunsThisWeek': !exists(json, 'failedRunsThisWeek') ? undefined : json['failedRunsThisWeek'],
        'itemsSyncedToday': !exists(json, 'itemsSyncedToday') ? undefined : json['itemsSyncedToday'],
        'itemsUpdatedToday': !exists(json, 'itemsUpdatedToday') ? undefined : json['itemsUpdatedToday'],
        'companiesSyncedToday': !exists(json, 'companiesSyncedToday') ? undefined : json['companiesSyncedToday'],
    };
}

export function WebApiAdminDtoIntegrationSyncSummaryDtoToJSON(value?: WebApiAdminDtoIntegrationSyncSummaryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'integrationName': value.integrationName,
        'configuredCompanies': value.configuredCompanies,
        'activeCompanies': value.activeCompanies,
        'lastSyncAt': value.lastSyncAt === undefined ? undefined : (value.lastSyncAt === null ? null : value.lastSyncAt.toISOString()),
        'runsToday': value.runsToday,
        'successfulRunsToday': value.successfulRunsToday,
        'failedRunsToday': value.failedRunsToday,
        'runsThisWeek': value.runsThisWeek,
        'failedRunsThisWeek': value.failedRunsThisWeek,
        'itemsSyncedToday': value.itemsSyncedToday,
        'itemsUpdatedToday': value.itemsUpdatedToday,
        'companiesSyncedToday': value.companiesSyncedToday,
    };
}

